import { RawListingDataSuggestion } from './types';
import { ListingModel } from '../Listing/Listing';
import { ListingType, ListingStatus } from '../Listing/types';
import { JSONObject } from '../Api/types';
import { ProcessStatus } from '../types';
import { Cloneable } from '../Utils/Cloneable';

export class ListingDataSuggestionModel extends Cloneable {
  id: string;
  listingId: string;
  listing: ListingModel;
  data: JSONObject;
  status: ProcessStatus;

  constructor(rawData: RawListingDataSuggestion) {
    super();
    this.id = rawData.id;
    this.listingId = rawData.listing_id;
    this.listing = new ListingModel(rawData.listing);
    this.data = rawData.data;
    this.status = rawData.status;
  }

  public isPending(): boolean {
    return this.status === ProcessStatus.PENDING;
  }

  public isApproved(): boolean {
    return this.status === ProcessStatus.APPROVED;
  }

  public isRejected(): boolean {
    return this.status === ProcessStatus.REJECTED;
  }

  public isOriginalSuggestion(): boolean {
    return this.data.is_unique === true;
  }

  public isFakeSuggestion(): boolean {
    return this.data.authentic === false;
  }

  public isSetSuggestion(): boolean {
    return this.data.multiple_items === true;
  }

  public getUpdatedListing(): ListingModel {
    // Create a clone of the listing and apply the suggested data changes
    const updatedListing = ListingModel.deepCopy(this.listing);

    // Apply data suggestions to the cloned listing
    if (this.data.type !== undefined) {
      updatedListing.type = this.data.type as ListingType;
    }
    if (this.data.is_unique !== undefined) {
      updatedListing.isUnique = this.data.is_unique as boolean;
      updatedListing.processingStatus = ListingStatus.APPROVED;
    }
    if (this.data.multiple_items !== undefined) {
      updatedListing.multipleItems = this.data.multiple_items as boolean;
      updatedListing.processingStatus = ListingStatus.APPROVED;
    }
    
    if (this.data.authentic !== undefined) {
      updatedListing.authentic = this.data.authentic as boolean;
      updatedListing.processingStatus = ListingStatus.REJECTED;
    }

    return updatedListing;
  }
}
